import { createSlice } from "@reduxjs/toolkit";

const usuarioSlice = createSlice({
    name: 'usuario',
    initialState: {
        usuario: [],
        permissaoDescItem: [],
        permissaoDescMov: [],
        permissaoDescCalculado: []
    },
    reducers: {
        addUsuario: (state, action) => {
            state.usuario = action.payload
        },
        addPermissaoDescItem: (state, action) => {
            state.permissaoDescItem = action.payload
        },
        addPermissaoDescMov: (state, action) => {
            state.permissaoDescMov = action.payload
        },
        addPermissaoDescCalculado: (state, action) => {
            state.permissaoDescCalculado = action.payload
        }
    }
});

export const { addUsuario, addPermissaoDescItem, addPermissaoDescMov, addPermissaoDescCalculado } = usuarioSlice.actions;
export default usuarioSlice.reducer;